import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { StoreTrailersFetchProps } from 'types/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'
import { fetchStoreTrailers } from 'queries/trailer/fetchStoreTrailers'
import { IStoreTrailersResponse } from 'utils/api'
import { stripInitialTAndLeadingZeroes } from 'utils/item-search'

export function useStoreTrailers({
    env,
    accessToken,
    location,
}: StoreTrailersFetchProps): IStoreTrailersResponse {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME
    const simpleLocation = stripInitialTAndLeadingZeroes(location ?? '')
    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.STORE_TRAILERS, location],
        () =>
            fetchStoreTrailers({
                env,
                accessToken,
                location,
                filters: {
                    store_id: simpleLocation,
                },
                trackEvent,
            }),
        {
            staleTime: 0,
            refetchInterval: tenMinutes,
            refetchIntervalInBackground: false,
            refetchOnWindowFocus: false,
            cacheTime: tenMinutes,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
